import { ProgressBar } from '../business-loan-application/components/progress-bar';
import { StepOne } from './components/step-one';
import { StepTwo } from './components/step-two';
import { StepThree } from './components/step-three';
import { SupremeError } from './components/supreme-error';
import { SupremeCardApplicationProps } from './types';
import { useSupremeCardApplication } from './use-supreme-card-application';
import clsx from 'clsx';

export const SupremeCardApplication = (props: SupremeCardApplicationProps) => {
    const { labels, defaultCard, hiddenCards, deferredSigningUrl, useMAPI = false } = props;
    const {
        step,
        updateField,
        updateOffer,
        onSubmit,
        fields,
        isLoading,
        offer,
        updatedOffer,
        error,
        mapiError,
        parseMapiErrors,
        errorTitle,
        fieldErrors,
        setFieldErrors,
        shouldFocusError,
        setShouldFocusError,
    } = useSupremeCardApplication({
        labels,
        defaultCard,
        hiddenCards,
        deferredSigningUrl,
        useMAPI,
    });

    const onAmountChange = (amount: number) => {
        updateField({ amount });
    };

    const onAfterAmountChange = (amount: number) => {
        updateField({ amount });
        updateOffer(amount);
    };

    const getErrorMessages = () => {
        return mapiError
            ? parseMapiErrors(mapiError)
            : {
                  errorTitle,
                  error: error || '',
              };
    };

    const renderCurrentComponent = () => {
        const stepProps = {
            fields,
            updateField,
            onSubmit,
            isLoading,
            useMAPI,
            fieldErrors,
            setFieldErrors,
            shouldFocusError,
            setShouldFocusError,
            ...props,
        };

        if (error || mapiError) {
            const { errorTitle, error } = getErrorMessages();
            return <SupremeError labels={props.labels} errorTitle={errorTitle} error={error} />;
        }

        switch (step) {
            case 1:
                return <StepOne {...stepProps} />;
            case 2:
                return (
                    <StepTwo
                        {...{
                            ...stepProps,
                            onAmountChange,
                            onAfterAmountChange,
                            offer,
                            updatedOffer,
                        }}
                    />
                );

            case 3:
                return <StepThree blocks={props.thankyouPageInnerBlocks} />;
        }
    };

    return (
        <div data-component="supreme-card-application">
            {!useMAPI ? <ProgressBar step={step} oldSkool /> : null}
            <div
                className={clsx('r-pb-1.5 r-pt-0.5', {
                    'r-mt-12': !useMAPI,
                })}
            >
                {renderCurrentComponent()}
            </div>
        </div>
    );
};
